<template>
  <div id="app">
    <router-view/>
    <tag/>
  </div>
</template>
<script>
import Tag from '@/views/tag'
export default {
  components:{
    Tag
  }
}
</script>
<style lang="scss">
body{
  margin: 0 !important;
}
@font-face {
  font-family: "HarmonyOS_Sans_Black";
  //src: url('./assets/font/HarmonyOS_Sans_Black.ttf') format('woff2');
  src: url('./assets/font/HarmonyOS_Sans_Medium.ttf') format('woff2');
  font-weight: normal;
  font-style: normal;
}
//#app {
//  font-family: Avenir, Helvetica, Arial, sans-serif;
//  -webkit-font-smoothing: antialiased;
//  -moz-osx-font-smoothing: grayscale;
//  text-align: center;
//  color: #2c3e50;
//}
//
//nav {
//  padding: 30px;
//
//  a {
//    font-weight: bold;
//    color: #2c3e50;
//
//    &.router-link-exact-active {
//      color: #42b983;
//    }
//  }
//}
</style>
